import * as actionTypes from './actionTypes';

export const loading = () => ({
    type: actionTypes.LOADING
});

export const loaded = () => ({
    type: actionTypes.LOADED
});

export const loadedUserSizeData = (sizeData) => ({
    type: actionTypes.LOADED_USER_SIZE_DATA,
    sizeData
})

export const deletedFilesReduceSize = (files) => ({
    type: actionTypes.DELETED_FILES_SIZE_DATA,
    files
})

export const addedFilesUpdateSize = (files) => ({
    type: actionTypes.ADDED_FILES_SIZE_DATA,
    files
})

export const loadedUserConfig = (config) => ({
    type: actionTypes.LOADED_USER_CONFIG,
    config
})

export const setCurrentLoginPage = (page) => ({
    type: actionTypes.CHANGED_LOGIN_PAGE,
    page
});

export const setDarkModeAction = (darkMode) => ({
    type: actionTypes.MANUALLY_SET_DARK_MODE,
    darkMode
});
